import React, { useEffect ,useState} from "react";
import axios from "axios";
import EChartsReact from "echarts-for-react";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler,
  ArcElement,
} from "chart.js";


const DoughnutChart = (props) => {
const [data,setData]=useState()
const [sum,setSum]=useState(0)
const [labels,setLabels]=useState([])
let  backgroundColor= ["#3b82f6", "#f69d0b","#15b8a7"]
var hoverBackgroundColor=["#3b82f6","#15b8a7","#f69d0b"]

useEffect(()=>{
  var temp = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: ["#3b82f6", "#f69d0b","#15b8a7"],
        hoverBackgroundColor: ["#3b82f6", "#f69d0b","#15b8a7"],
      },
    ],
  };


  let tempGraph=[]
    axios.get(process.env.REACT_APP_API_POINT +'DQ-pipeline/pipeline-details-Q2-MTD',{headers:{Authorization: 'Bearer '+sessionStorage.getItem('token')}}).then((data)=>{
      if(data.data.success){
 let tempSum=0
 let tempLabel=[]
        data.data['DQ-Pipeline-Details-Q2 MTD Data'].forEach(element => {
          tempLabel.push(element['Pipeline Flag'])
          temp.datasets[0].data.push(element['MTD Issues Occured'])
          tempGraph.push({name:element['Pipeline Flag'],value:element['MTD Issues Occured']})
          tempSum=tempSum+element['MTD Issues Occured']
        });
       setSum(tempSum)
        setData(tempGraph)
        setLabels(tempLabel)
      }
    })
  },[])
  
  
  const chartOptions = {
      
      tooltip: {
        trigger: "item"
      },
      title: {
        text: `Total Issues\n${sum}`,
        left: 'center',
        top: 'center',
     },
      series: [
        {
          name: "Access From",
          type: "pie",
          radius: ["70%","50%"],
          data:data,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              // shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }
      ],
      color:[backgroundColor[0],backgroundColor[1],backgroundColor[2]]
    }
    
  
  return (<div>
    <div className="App" >
      <EChartsReact option={chartOptions} />
    </div>
    <span className="d-flex justify-content-center" >{labels.map((label,index)=>{ return <><span className="m-2" style={{backgroundColor:backgroundColor[index], height:"12px",width:"12px",borderRadius:"5px"}}  /><span className="m-1" style={{fontSize:"16px"}}>{label}</span></>})}</span>
    </div>
  );

};

export default DoughnutChart;
